/** Expand backend abbreviations for UI / URL query display (backend may still send "ACT"). */
export function displayStateName(name: string | undefined | null): string {
  if (name == null) return '';
  const n = String(name).trim();
  if (n.toUpperCase() === 'ACT') return 'Australian Capital Territory';
  return n;
}
